import React from "react";
import {COMMON_PREFERENCE_TYPES} from "crqlar-react-common/dist/models/profile/preference.model";
import {labelizeUnderScoreText, useLocalize} from "crqlar-react-common/dist/utils/text.util";
import {AllergyElement} from "crqlar-react-common/dist/components/uiElements/AllergyElement";
import {ElementChipList} from "./base/ElementChipList";

interface Props {
    allergies: string[] | undefined;
    onClick?: (value: string) => void;
    onDelete?: (value: string) => void;
}

export function AllergiesElement({allergies, onClick, onDelete}: Props) {
    const {tFallback} = useLocalize();
    const uniqueAllergies = Array.from(new Set((allergies ?? []).filter(Boolean)));

    if (!uniqueAllergies.length) return null;

    return (
        <ElementChipList>
            {uniqueAllergies.map(value => (
                <AllergyElement
                    key={value}
                    label={tFallback(
                        `${COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_ALLERGY}_${value}`,
                        labelizeUnderScoreText(value),
                    )}
                    value={value}
                    onClick={onClick ? () => onClick(value) : undefined}
                    onDelete={onDelete ? () => onDelete(value) : undefined}
                />
            ))}
        </ElementChipList>
    );
}
